import React from "react";

export default function Logo() {
  return <img src="/images/logodtm.png" alt="Deiko TM" className="logodtm" />;
}
